import React from "react";
import styles from "@/styles/desktop/Footer.module.scss";
import type { SocialMediaItem } from "@/app/utils/socialMedia";

type HeaderProps = {
	logoSrc: string;
	brandName: string;
	socialMedia: SocialMediaItem[];
};

const Header: React.FC<HeaderProps> = ({ logoSrc, brandName, socialMedia }) => (
	<header className={styles.header}>
		<div className={styles.logoContainer}>
			<div className={styles.logoWrapper}>
				<img
					width={400}
					height={400}
					loading="lazy"
					src={logoSrc}
					alt="Company logo"
					className={styles.logo}
				/>
			</div>
			<div className={styles.brandName}>{brandName}</div>
		</div>
		<nav className={styles.socialNav}>
			{socialMedia.map(({ src, href, alt }) => (
				<a
					key={alt}
					href={href}
					target="_blank"
					rel="noopener noreferrer"
					aria-label={alt}
				>
					<img
						width={400}
						height={400}
						loading="lazy"
						src={src}
						alt={alt}
						className={styles.socialIcon}
					/>
				</a>
			))}
		</nav>
	</header>
);

export default Header;
